import { groupBy } from 'lodash';
import API from 'services/API';
import { moment } from 'utils';

export default function getSlots(query) {
  return API.request({
    method: 'GET',
    url: `/appointment/getSlots?fnsId=${query.taxAuthorityId}&serviceId=${query.serviceId}`,
    mapper: function (data = []) {
      const slots = data.map((slot) => {
        return { ...slot, visitTimeObject: moment(slot.visitTime) };
      });

      return groupBy(slots, (slot) => {
        return slot.visitTimeObject.format('DD.MM.YYYY');
      });
    },
  });
}
